import './TooltipCancelledShipmentContent.css'
import { date } from '../../../utils/formatter'

export const TooltipCancelledShipmentContent = ({ data }) => {
  return (
    <table className="tooltip-cancelled-shipment-content">
      <thead>
        <th colSpan={2}>
          <td>Cancelled Shipment Details</td>
        </th>
      </thead>
      <tbody>
        {data?.shipmentCancelTimestamp && (
          <tr>
            <td>Shipment Cancel Timestamp</td>
            <td>{date(data.shipmentCancelTimestamp)}</td>
          </tr>
        )}
        {data?.updatedByIdentifier && (
          <tr>
            <td>Updated By</td>
            <td>{data.updatedByIdentifier}</td>
          </tr>
        )}
        {data?.shipmentTexts && data.shipmentTexts[0]?.textDescription && (
          <tr>
            <td>Cancel Reason</td>
            <td>{data.shipmentTexts[0].textDescription}</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default TooltipCancelledShipmentContent
